export const fontSize = {
  xxxlarge: "28px",
  xxlarge: "24px",
  xlarge: "20px",
  large: "18px",
  medium: "16px",
  small: "14px",
  xsmall: "12px",
  xxsmall: "8px",
  xxxsmall: "5px",
  xxxxsmall: "4px",
} as const;

export type FontSize = keyof typeof fontSize;
